/**
 * Activity-Beta Subroute
 * Initialize all the Colletion, Model and View components needed for the page
 */

import $ from 'jquery';
import SubRouteHelper from './helper';
import activitySetup from './activitySetup';

export default SubRouteHelper.extend({

	// Register all the interesting URIs
	routes: {
		'': 'initializeComponents' // default activity view
	},

	initializeComponents() {
		let serverData = $('#js_activityView').data();

		// sets up BackboneJS objects needed for page load
		activitySetup('activity', serverData);
	}
});



// WEBPACK FOOTER //
// ./routes/activity.es6